import { render, staticRenderFns } from "./ONavBottom.vue?vue&type=template&id=276e53b4"
import script from "./ONavBottom.vue?vue&type=script&lang=js"
export * from "./ONavBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports